export default __webpack_public_path__ + "static/media/HAT.4a46bd42.png";